!function(name, module, context) {
	//>>excludeStart("requireTmpl", pragmas.requireTmpl);
	if(window.define) define('hotels/recentViewed',['libs/ct_view', 'libs/ct_store', 'hotels/hotelPers', 'vendor/mustache', 'vendor/moment.min'], module)
	else
	//>>excludeEnd("requireTmpl");
		context[name] = module(CT.View, CT.Store, CT.Pers, Mustache)
}('recentViewed', function(View, Store, Pers, Mustache) {
	var pers = new Pers();

	function getTravellerInfo(numRooms, los, numAdults, numChilds){
		var travellerInfo = "";
			travellerInfo += (numRooms + " room" + (numRooms > 1 ?  "s" : "") + " for ");
			travellerInfo += (los > 0 ? (los + " Night, " ) : "");
			travellerInfo += (numAdults > 0  ? (numAdults + " Adult" + ( numAdults>1 ? "s" : "")) : "");
			travellerInfo += (numChilds > 0  ? (", " + numChilds + " Child" + ( numChilds>1 ? "s" : "")) : "");
		return travellerInfo;
	}

	function getLenghtOfStay(chkIn , chkOut){
		var los = 0;
		if(chkIn && chkOut){
			los = moment(chkOut, "DD/MM/YYYY").diff(moment(chkIn, "DD/MM/YYYY") , 'days');
		}
		return los;
	}

	function getNavigateUrl (hotel){
		var url; 
			url = "/hotels/details/"+hotel.id + "?c=" + hotel.cDet + "&r=" + hotel.travellerDet;
		return url;
	}	

	function getRecentViewedData (){
		var data;
		data =pers.get('recentlyViewed');
		data = data ? data.reverse() : [];
		var now = moment(); //Getting the current date
		
		//Removing Expired checkin dates while displaying 
		data = _.filter(data, function(recentObj){
			return moment(recentObj.chkIn, "DD/MM/YYYY").diff(now,'days') >= 0; 
		})

		_.each(data, function(recentObj,idx){
			recentObj.checkIn = moment(recentObj.chkIn, "DD/MM/YYYY").format('D MMM, YYYY');
			recentObj.checkOut = moment(recentObj.chkOut, "DD/MM/YYYY").format('D MMM, YYYY');
			var los = getLenghtOfStay(recentObj.chkIn , recentObj.chkOut);
			recentObj.travellerInfo = getTravellerInfo(recentObj.numRooms, los, recentObj.adults, recentObj.childs);
			recentObj.navigatUrl = getNavigateUrl(recentObj);
			if(recentObj.tnPath){
				recentObj.tnPath = recentObj.tnPath.replace(
					'ui.cltpstatic.com',
					(
						'fastui.cltpstatic.com/image/upload/hotels'
						+ (window.location.host.startsWith("qa2") ? '_qa' : '')
					)
				);
			}
			if(idx > 1){
				recentObj.isHidden = true;
			}else{
				recentObj.isHidden = false;
			}
		});

		return data;
	}

	function cancelRecentFn(){
		var pers = new Pers();
		var refAnc = $(this.$el).find(".cancelRecent");
		CT.utils.helperFunctions.trackClaverTapEvtHotel('Hotel_Home_closeRecentView_click',{});
		pers.clear('recentlyViewed');
		this.$el.fadeOut();
	}

	function bindEvents(){
		$(this.$el).find(".recentViewed__seeMore").bind('click' , showMore.bind(this));
		$(this.$el).find(".navigateToDetail").bind('click' , navigateToDetailPage.bind(this));
	}

	function showMore(){
		var $parent = $(this.$el).find("ul#RecentViewed");
		$parent.find("li").show();
		CT.utils.helperFunctions.trackClaverTapEvtHotel('Hotel_Home_moreRecentView_click',{});
		$parent.find(".recentViewed__seeMore").remove();
	}

	function navigateToDetailPage(evt){
		var evt = evt || window.event;
		var $target = $(evt.currentTarget);
		var url = $target.attr("navigatUrl");
		if(url){
			CT.utils.helperFunctions.trackClaverTapEvtHotel('Hotel_Home_RecentView_click',{
	           "destinationCity" : $target.attr("city"),
	        	"hotelID" : $target.attr("hotelid"),
	        	"hotelName" : $target.attr("hotelname") 
	        });
		}
	}

	var recentViewedView = View({
		$el: $('.recentViewed'),

		initialize: function() {
			$(this.$el).find(".cancelRecent").bind('click', cancelRecentFn.bind(this));
		},

		hideRecent: function() {
			$(this.$el).hide();
		},

		showRecent: function() {
			$(this.$el).show();
		},

		render: function() {
			if(window.enableRecentView && window.product != "B2B"){
				var recentData = getRecentViewedData();
				if(recentData.length >= 1){
					recentData = _(recentData).slice(0,4).value();
					var mustachData = {
						"recent" : recentData,
						"isShowMoreLink" : (recentData.length > 2),
					};
					var html = CT.to_html('RecentViewedTmpl', mustachData);
					$(this.$el).find('#RecentViewed').html(html);
					this.showRecent();
					bindEvents.bind(this)();
				}else{
					this.hideRecent();
				}
			}else{
				this.hideRecent();
			}
			
		}
	});


	return recentViewedView;
}, CT.cache.views)
;
